import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'

const SearchInput = ({ themeColor, query, setSearchQuery, searchLoading, hideSearchResults, setHideSearchResults }) => {
  const searchInput = useRef(null)

  useEffect(() => {
    searchInput.current.focus()
  }, [])

  useEffect(() => {
    if (query && query.length) searchInput.current.focus()
  }, [query])

  return (
    <InputWrapper>
      <InputAppendPrepend>
        {searchLoading ? (
          <i style={{ color: `${themeColor}` }} className="fas fa-spinner-third fa-spin" />
        ) : (
          <i className="far fa-search" />
        )}
      </InputAppendPrepend>
      <Input
        onClick={() => {
          if (hideSearchResults && query && query.length) setHideSearchResults(false)
        }}
        ref={searchInput}
        value={query || ''}
        placeholder="Search..."
        onChange={e => {
          setSearchQuery(e.target.value)
        }}
      />
      <InputAppendPrepend>
        {query && query.length >= 1 && (
          <i
            onClick={() => {
              setSearchQuery(null)
            }}
            style={{ cursor: 'pointer' }}
            className="fad fa-times-circle"
          />
        )}
      </InputAppendPrepend>
    </InputWrapper>
  )
}

export default SearchInput

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.borderColor};
`
const Input = styled.input`
  height: 46px;
  padding: 0.4rem 0.1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
  border: 0px;
  outline: 0px;
  box-shadow: none;
  background: transparent;
  color: ${props => props.theme.textGreyTintedDarker};
`
const InputAppendPrepend = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0.5rem 0.75rem;
  line-height: 1.25;
  font-size: 1rem;
  color: ${props => props.theme.textGreyTinted};
  .far {
    margin-top: 2px;
  }
  .fad {
    margin-top: 3px;
  }
`
